<template>
  <div class="personal">
    <Navbar title="个人信息" :default-bg="false" :service="true" :phone="1555555555"/>
    <div class="personalInfo">
      <div class="cart">
        <div class="describe">
          <span>姓名</span>
          <input type="text" v-model="newName" placeholder="请输入姓名"
                 @input="changeInputVal($event,/[^a-z0-9A-Z\u4e00-\u9fa5]+/g,'newName',0,6)"/>
        </div>
        <div class="describe">
          <span>手机号</span>
          <div class="next" @click="toPages('/my/bindPhoneStep1')">
            <span>{{ userMobile }}</span>
            <img src="../../assets/images/me/next.png" alt="">
          </div>
        </div>
        <div class="describe">
          <span>{{ userType == 0 ? '病历号' : '员工号' }}</span>
          <input type="text" v-model="newNumber" :placeholder="`请输入${userType==0?'病历号':'员工号'}`"
                 @input="changeInputVal($event,/[^a-z0-9A-Z]+/g,'newNumber',0,10)"/>
        </div>
      </div>
    </div>
    <div class="save">
      <button class="themeColor" @click="userSaveInfo">保存</button>
    </div>
    <div class="bindNo">
      <span @click="toPages('/my/bindStaffNo')">绑定员工号</span>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Dialog, Toast} from "vant";

export default {
  name: "personal",
  components: {Navbar},
  data() {
    return {
      userMobile: '',
      userName: '',
      userNumber: '',
      userType: "",
      newName: "",
      newNumber: ""
    }
  },
  created() {
    this.userType = localStorage.getItem('user_type');
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    changeInputVal(e, reg, key, min = 0, max) {
      this[key] = e.target.value.replace(reg, '').slice(min, max);
    },
    toPages(url) {
      // if (url == '/my/bindStaffNo') {
      //   if (this.userType == 0) {
      //     return Toast('您没有权限');
      //   } else {
      //     this.$router.push(url)
      //   }
      // } else {
      //   this.$router.push(url)
      // }
      this.$router.push(url)
    },
    getUserInfo() {
      this.$post('user/info').then(res => {
        this.$post('user/antianaphylaxis').then(res => {
          if (res.status == 200) {
            let data = res.data
            this.$data.userMobile = data.userMobile
            this.$data.userName = data.userName
            this.$data.newName = data.userName
            this.$data.userNumber = data.userNumber
            this.$data.newNumber = data.userNumber
          }
        })
      })
    },
    userSaveInfo() {
      if (this.newName == this.userName && this.newNumber == this.userNumber) {
        return
      }
      if (!this.newName) {
        return Toast('请填写名字')
      }
      if (!this.newNumber) {
        let str = this.userType == 0 ? '请填写病历号' : '请填写员工号'
        return Toast(str)
      }
      let data = {
        userNumber: this.newNumber,
        name: this.newName
      }
      this.$post('user/saveInfo', data).then(res => {
        if (res.status == 200) {
          // this.getUserInfo()
          Toast.success('修改成功')
          localStorage.removeItem('user_type');
          localStorage.removeItem('user_token');
          setTimeout(() => {
            Dialog.alert({
              title: "提示",
              message: "用户信息已变更，请重新登录",
              confirmButtonColor: '#126AFC',
            }).then(() => {
              this.$router.push('/login')
            })
          }, 100)
        } else {
          Toast(res.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.personal {
  height: 100vh;
  font-size: 12px;
  position: relative;

  .personalInfo {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 20px;

    .cart {
      background: #FFFFFF;
      padding: 0 15px;
      box-sizing: border-box;
      font-size: 14px;
      color: #333333;
      border-radius: 8px;

      .describe {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #EEEEEE;

        .next {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            margin-right: 8px;
          }

          img {
            height: 12px;
          }
        }

        input {
          border: none;
          text-align: right;
        }
      }

      .describe:last-child {
        border-bottom: none;
      }
    }
  }

  .save {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 70px;

    button {
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .bindNo {
    width: 100%;
    position: absolute;
    bottom: 17px;
    display: flex;
    justify-content: center;
    font-size: 15px;
    color: #999999;
  }
}
</style>